import React, { useState } from 'react';
import { reportsService } from '../../services/api';

export default function ReportEmail({ patient }) {
  const [pdf, setPdf] = useState(null);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState('');
  const email = patient?.email?.trim();
  if (!email) return <p>Cadastre o e-mail da paciente para enviar o relatório.</p>;

  async function send(event) {
    event.preventDefault();
    const form = event.currentTarget;
    if (!pdf || sending) return;
    setSending(true);
    setResult('');
    try {
      const response = await reportsService.sendEmail(patient.id, email, pdf);
      setResult(response.message || 'Relatório aceito pelo servidor de e-mail.');
      setPdf(null);
      form.reset();
    } catch (error) {
      setResult(error.response?.data?.error || 'Não foi possível confirmar o envio.');
    } finally {
      setSending(false);
    }
  }

  return <details style={{ margin: '1rem' }}>
    <summary style={{ cursor: 'pointer' }}>Enviar relatório por e-mail</summary>
    <form onSubmit={send}>
      <p>Destinatária: <strong>{email}</strong></p>
      <p>Use Imprimir / Salvar PDF e selecione o PDF salvo (até 5 MB).</p>
      <input aria-label="PDF do relatório" type="file" accept="application/pdf,.pdf" required
        onChange={event => { setPdf(event.target.files[0]); setResult(''); }} />
      <button type="submit" disabled={!pdf || sending}>{sending ? 'Enviando…' : 'Enviar PDF'}</button>
      {result && <p role="status">{result}</p>}
    </form>
  </details>;
}
